export type SiteBrand = 'howdoyouexcel' | 'excelafterdark';

const requestedBrand = import.meta.env.VITE_SITE_BRAND?.toLowerCase();

export const siteBrand: SiteBrand =
  requestedBrand === 'excelafterdark' ? 'excelafterdark' : 'howdoyouexcel';

export const isExcelAfterDark = siteBrand === 'excelafterdark';

export const siteConfig = isExcelAfterDark
  ? {
      name: 'Excel After Dark',
      domain: 'excelafterdark.com',
      url: 'https://excelafterdark.com',
      description:
        'Original Excel tools, experiments, and unexpected solutions built after hours.',
      footer:
        'Original Excel tools and unexpected solutions, built after hours.',
      trainingUrl: 'https://loveyourexcel.com',
      theme: {
        header: 'bg-slate-950',
        accentText: 'text-fuchsia-600',
        button: 'bg-fuchsia-700 hover:bg-fuchsia-800',
        buttonText: 'text-fuchsia-700',
        buttonBorder: 'border-fuchsia-700',
        buttonHover: 'hover:bg-fuchsia-50',
        icon: 'text-fuchsia-500',
      },
    }
  : {
      name: 'How do you Excel?',
      domain: 'howdoyouexcel.com',
      url: 'https://howdoyouexcel.com',
      description:
        'Practical Excel add-ins, templates, tutorials, formulas, and workflow solutions.',
      footer: 'Your one-stop destination for Excel solutions and learning.',
      trainingUrl: 'https://loveyourexcel.com',
      theme: {
        header: 'bg-[#217346]',
        accentText: 'text-green-600',
        button: 'bg-green-600 hover:bg-green-700',
        buttonText: 'text-green-600',
        buttonBorder: 'border-green-600',
        buttonHover: 'hover:bg-green-50',
        icon: 'text-green-500',
      },
    };

